import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UserService } from '../../../../api/services'
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms'
import { User } from '../../../../api/models'

@Component({
  selector: 'app-user-profile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css'],
})
export class UserprofileComponent implements OnInit {
  userForm: UntypedFormGroup
  user: User
  displaypopup: boolean = false
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.displaypopup = true
    this.userForm = new UntypedFormGroup({
      ehrUserName: new UntypedFormControl(null, []),
      loginId: new UntypedFormControl(null, []),
      lname: new UntypedFormControl(null, []),
      fname: new UntypedFormControl(null, []),
      mi: new UntypedFormControl(null, []),
      emailAddress: new UntypedFormControl(null, []),
      cellNo: new UntypedFormControl(null, []),
      userRole: new UntypedFormControl(null, []),
      active: new UntypedFormControl(null, []),
    })
    this.loaduserprofile()
  }

  loaduserprofile() {
    this.userService.userViewprofile({}).subscribe((data) => {
      console.log(data)
      if (data) {
        this.userForm.patchValue(data)
        debugger
        this.userForm.controls.userRole.setValue(data.roles.roleName)
      }
    })
  }
}
